const mapFramesizeFacetToLabelKeys = (framesize)=>{
    switch(framesize){
        case 'LARGE':
            return {
                title: 'products.facets.frameSize.wide.title',
                subtitle: 'products.facets.frameSize.wide.subTitle'
            };
        case 'MEDIUM':
            return {
                title: 'products.facets.frameSize.average.title',
                subtitle: 'products.facets.frameSize.average.subTitle'
            };
        case 'SMALL':
            return {
                title: 'products.facets.frameSize.narrow.title',
                subtitle: 'products.facets.frameSize.narrow.subTitle'
            };
        case 'EXTRA_SMALL':
            return {
                title: 'products.facets.frameSize.kids.title',
                subtitle: 'products.facets.frameSize.kids.subTitle'
            };
        default:
            return undefined;
    }
};

export { mapFramesizeFacetToLabelKeys };
//# sourceMappingURL=map-framesize-facet-to-label-keys.js.map
